import {Component, OnInit} from '@angular/core';
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";
import {Router} from "@angular/router";
import {ModalController, NavController} from "@ionic/angular";
import {AuthService} from "../../../../services/mygreencountry/auth.service";
import {StudentRequestComponent} from "../../../../shared/components/modals/student-request/student-request.component";
import {StudentSelfDashboard, StudentSelfGroup} from "../../../../types/interfaces";
import {PreloaderService} from "../../../../services/preloader/preloader.service";
import {StudentService} from "../../../../services/mygreencountry/student.service";
import {TelegramComponent} from "../../../../shared/components/modals/chose-group/telegram/telegram.component";
import {PracticingComponent} from "../../../../shared/components/modals/chose-group/practicing/practicing.component";
import {BirthdayCardComponent} from "../../../../shared/components/modals/birthday-card/birthday-card.component";
import {
    TransferLessonsComponent
} from "../../../../shared/components/modals/transfer-lessons/transfer-lessons.component";
import {NewExamComponent} from "../../../../shared/components/modals/new-exam/new-exam.component";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {
    EditChildPhotoComponent
} from "../../../../shared/components/modals/edit-child-photo/edit-child-photo.component";
import {AppUpdatesInfo} from "../../../../types/apiResponse.interface";
import {AppUpdatesComponent} from "../../../../shared/components/modals/app-updates/app-updates.component";


@Component({
    selector: 'app-student-dashboard',
    templateUrl: './student-dashboard.component.html',
    styleUrls: ['./student-dashboard.component.scss'],
})
export class StudentDashboardComponent implements OnInit {
    protected readonly length = length;

    activeFuturesGroupsTabs = false;
    activePassedGroupsTabs = false;
    activeCurrentGroupsTabs = true;

    activeTabGroups: StudentSelfGroup[];
    processRequest: boolean = false;
    currentGroups: StudentSelfGroup[];

    hasEnterTest: boolean = false;
    onlineTestRequired: boolean = false;
    showBirthdayCard: boolean = false;

    student: StudentSelfDashboard | null = null;
    studentHasGroups: boolean | null = null;
    studentHasRework: boolean = false;

    videoLink: string = 'https://www.youtube.com/embed/A_SUeielXHA';
    saveVideoLink: SafeResourceUrl;

    activeGroupTime$ = this.GCService.getActiveGroupTime();

    hasNewUpdates: boolean = false;
    showNewUpdatesModal: boolean = false;

    constructor(
        public myGcService: MyGreenCountry,
        private authService: AuthService,
        public router: Router,
        public navCtrl: NavController,
        private modalCtrl: ModalController,
        private preloaderService: PreloaderService,
        private studentService: StudentService,
        private GCService: MyGreenCountry,
        private sanitizer: DomSanitizer,
    ) {
    }

    refresh(event: any) {
        this.loadData(null, event);
    }


    ngOnInit() {
        this.loadData(null);
    }

    onTabChange(activeTabTime: string) {
        this.getDashboard(activeTabTime);
    }

    async openModal(type: string) {
        if (this.activeTabGroups) {
            await this.openChoseGroupModal(type)
        }
    }

    async openEditPhotoModal() {

        const modal = await this.modalCtrl.create({
            component: EditChildPhotoComponent,
            cssClass: 'edit-child-photo-modal',
            componentProps: {
                childId: this.student?.id ?? null,
                selectedImageBase: this.student?.avatar ?? null
            }
        });

        modal.onWillDismiss().then(({data, role}) => {
            if (role === 'reload') {
                this.loadData(null);
            }
        });


        await modal.present();
    }

    async openChoseGroupModal(type: string) {

        const modal = await this.modalCtrl.create({
            component: type === 'practicing' ? PracticingComponent : TelegramComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                groups: this.activeTabGroups,
                type: type,
            }
        });

        modal.onWillDismiss().then(({data, role}) => {
            if (role === 'openTransferModal') {
                this.openTransferModal();
            }
        });


        await modal.present();
    }

    async openTransferModal() {

        const modal = await this.modalCtrl.create({
            component: TransferLessonsComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                groups: this.activeTabGroups,
            }
        });

        modal.onWillDismiss().then(({data, role}) => {
            if (role === 'reload') {
                this.loadData(null);
            }
        });

        await modal.present();

    }

    openUrl(url: string) {
        if (url) {
            this.myGcService.openUrl(url);
        }
    }

    async openRequestModal(type: string) {

        let modal = await this.modalCtrl.create({
            component: StudentRequestComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                type: type,
            }
        });

        await modal.present();
    }

    async getDashboard(activeTab: string | null, event: any = null) {
        await this.preloaderService.showLoading('Зачекайте, будь ласка');
        this.processRequest = true;

        this.studentService.getDashboard(activeTab)

            .subscribe({

                next: (response) => {
                    this.student = response;

                    if (this.student.videoLink) {
                        this.videoLink = this.student.videoLink;
                    }

                    this.createSafeUrl(this.videoLink);
                    this.GCService.setActiveGroupTime(this.student.activeTimeTab)
                    this.studentHasGroups = this.student.totalGroupAmount > 0;
                    this.checkTabsPriority()

                    if (this.student?.showBirthdayCard) {
                        this.openBirthdayModal(this.student.studentPhone);
                    }

                    this.newExamModal();

                    if (this.studentHasGroups) {
                        this.filterGroups();
                    }

                    this.hasEnterTest = this.student.hasEnterTest;
                    this.onlineTestRequired = this.student.onlineTestRequired;
                    this.studentHasRework = this.student.reworkLessons.length > 0;
                    // this.futureGroups = this.student.groups.filter(group => group.time === 'isFuture');
                    // this.pastGroups = this.student.groups.filter(group => group.time === 'isPast');
                    // this.currentGroups = this.student.groups.filter(group => group.time === 'isCurrent');
                    //
                    // this.checkTabsPriority()
                },

                error: (error) => {

                    if (error.status === 422 || error.status === 401 || error.status === 404 || error.status === 500) {
                        this.authService.logout();
                    }
                },

                complete: () => {
                    this.preloaderService.hideLoading();
                    this.processRequest = false;

                    if (event) {
                        event.target.complete();
                    }
                }
            })
    }

    async loadData(activeTab: string | null, event: any = null) {
        this.getDashboard(null, event);
    }


    filterGroups() {

        if (this.student && this.student.groups) {

            let activeTabTime = this.activeGroupTime$.value;

            let updateGroupData = (groupTime: string, time: string, groups: any[]) => {
                let filteredGroups = groups.filter(group => group.time === groupTime);
                let paidGroups = filteredGroups.filter(group => !group.isReserve);
                let groupIds = filteredGroups.map(group => group.id);
                let paidGroupIds = paidGroups.map(group => group.id);
                // this.activeGroups = filteredGroups;

                // this.persistenceService.set(`activeGroupsIds`, groupIds);
                this.studentService.setActiveGroupsIds(groupIds)
                this.studentService.setActivePaidGroupsIds(paidGroupIds)

                this.studentService.setCurrentGroupsLinks(filteredGroups.map(group => ({
                    title: group.title,
                    time: group.time,
                    parentMeetingUrl: group.parentMeetingUrl,
                    studentsMeetingUrl: group.studentsMeetingUrl,
                    parentMeetingUrlZNO: group.parentMeetingUrlZNO,
                    practicingUrl: group.practicingUrl,
                    telegramUrlFullCourse: group.telegramUrlFullCourse,
                    telegramUrl: group.telegramUrl,
                    isFullCourse: group.isFullCourse,
                    typeCourse: group.typeCourse,
                    id: group.id,
                    isReserve: group.isReserve
                })));

                if (groupTime == 'isCurrent') {
                    // this.persistenceService.set('currentPaidGroups', paidGroups);
                }

                this.activeTabGroups = filteredGroups;
            };

            switch (activeTabTime) {
                case 'isPast':
                    updateGroupData('isPast', 'past', this.student.groups);
                    break;
                case 'isFuture':
                    updateGroupData('isFuture', 'future', this.student.groups);
                    break;
                case 'isCurrent':
                    updateGroupData('isCurrent', 'current', this.student.groups);
                    break;
                default:
                    updateGroupData('isCurrent', 'current', this.student.groups);
                    break;
            }

        }
    }

    checkTabsPriority() {
        this.activeCurrentGroupsTabs = false;
        this.activePassedGroupsTabs = false;
        this.activeFuturesGroupsTabs = false;

        if (this.student?.activeTimeTab == 'isFuture') {
            this.activeFuturesGroupsTabs = true;
        } else if (this.student?.activeTimeTab == 'isPast') {
            this.activePassedGroupsTabs = true;
        } else {
            this.activeCurrentGroupsTabs = true;
        }
    }


    async openBirthdayModal(phone: string) {
        let modal = await this.modalCtrl.create({
            component: BirthdayCardComponent,
            cssClass: 'auto-height birthday-card',
            componentProps: {
                phone: phone,
            }
        });

        await modal.present();
    }

    async openNewExamModal() {
        let modal = await this.modalCtrl.create({
            component: NewExamComponent,
            cssClass: 'auto-height',

        });

        modal.onWillDismiss().then(({data, role}) => {
            if (role === 'goToTestPage') {
                this.router.navigate(['/tests']);
            }
        });

        await modal.present();
    }

    newExamModal() {
        if (this.student && this.student?.newExams > 0) {
            let date = new Date(),
                currData = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate(),
                showExamsInfoModal = true;

            if (this.studentService.getExamInfoShowAt() == currData) {
                showExamsInfoModal = false;
            }

            if (showExamsInfoModal) {
                this.openNewExamModal();

                this.studentService.setExamInfoShowAt(currData);
            }

        }
    }

    createSafeUrl(videoLink: string) {
        this.saveVideoLink = this.sanitizer.bypassSecurityTrustResourceUrl(videoLink);
    }
}
